import React from "react";
import { observer } from "mobx-react-lite";
import { Button, CircularProgress } from "@mui/material";
import { translationService } from "../../services/translation/TranslationService";
import { ApprovedList } from "./useApprovedList";

interface SaveListButtonProps {
  approved: ApprovedList;
}

/**
 * The one Save list button, used wherever an approved list can be saved.
 *
 * Every copy used to decide for itself when it was enabled: the OCR list asked `dirty`, the
 * analysis lists asked `canSubmit`. `dirty` is the wrong question -- a stored list that still has
 * to be signed off has nothing pending, so that button greyed out exactly when the sign-off was
 * the only thing left to do. One component, one rule.
 *
 * The screen itself is held by the page's SavingBackdrop while `saving` is true.
 */
const SaveListButton: React.FC<SaveListButtonProps> = observer(({ approved }) => (
  <Button
    size="small"
    variant="contained"
    disabled={!approved.canSubmit || approved.saving}
    startIcon={approved.saving ? <CircularProgress size={14} color="inherit" /> : undefined}
    onClick={() => void approved.save()}
    data-html2canvas-ignore
  >
    {translationService.translate("comparison.approved-list.save")}
  </Button>
));

export default SaveListButton;
